import { SEOHead } from "@components/organisms";
import { InnerPageLayout } from "@components/templates";
import { AccordionItem } from "@components/atoms";
import { useFaqs } from "@shared/hooks";

/**
 * FAQ page ("Preguntas Frecuentes").
 * Accordion list of FAQs loaded from the CMS API.
 */
export function FAQPage() {
  const { data: faqs, isLoading, error } = useFaqs();

  return (
    <>
      <SEOHead title="Preguntas Frecuentes" />
      <InnerPageLayout title="Preguntas Frecuentes">
        <div className="flex flex-col px-4 sm:pl-8 pb-4 ">
          {isLoading && (
            <p className="text-primary-110" style={{ fontSize: 14 }}>
              Cargando...
            </p>
          )}
          {error && (
            <p className="text-red-500" style={{ fontSize: 14 }}>
              No se pudieron cargar las preguntas frecuentes.
            </p>
          )}
          {faqs?.map((item) => (
            <AccordionItem
              key={item.id}
              question={item.question}
              answer={item.answer}
            />
          ))}
        </div>
      </InnerPageLayout>
    </>
  );
}
